import React from 'react';
import PropTypes from 'prop-types';

const ProgressBar = ({ index, ratingDistribution, totalReviews }) => {
  const barCoverage = ratingDistribution[index]
    ? (ratingDistribution[index] / totalReviews) * 100
    : 0;
  return (
    <div className="o-grid__item">
      <div
        className="c-progress-bar"
        aria-valuemin="0"
        aria-valuemax="100"
        aria-valuenow={barCoverage}
        role="progressbar"
      >
        <span
          className="c-progress-bar__value"
          style={{ width: `${barCoverage}%` }}
        >
          <span className="u-hide-visually">{barCoverage}%</span>
        </span>
      </div>
    </div>
  );
};

export default ProgressBar;

ProgressBar.propTypes = {
  index: PropTypes.number.isRequired,
  ratingDistribution: PropTypes.shape({
    /* key value pairs */
  }),
  totalReviews: PropTypes.number.isRequired,
};
